var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userLogs && _vm.userLogs.length > 0
    ? _c(
        "div",
        _vm._l(_vm.userLogs, function (userLog, index) {
          return _c(
            "div",
            { key: `userLog-${index}` },
            [
              _c(
                "div",
                { staticClass: "pt-2" },
                [
                  _vm.getUserLogs(userLog) &&
                  _vm.getUserLogs(userLog).length > 0
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "my-0 ml-1 mr-0",
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.toggle(index)
                            },
                          },
                        },
                        [
                          _c("v-icon", [
                            _vm._v(
                              _vm._s(
                                _vm.hide[index] ? "expand_more" : "expand_less"
                              )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-chip",
                    {
                      staticClass: "ma-0",
                      attrs: { color: "transparent", small: "", label: "" },
                    },
                    [
                      _c(
                        "v-avatar",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pl-1",
                              attrs: { color: _vm.getColor(userLog) },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.getIcon(userLog)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.getTimeStamp(userLog)) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "pa-2 mx-1 card-bg-1 rounded-border" },
                _vm._l(_vm.getMessage(userLog), function (line, lineIndex) {
                  return _c("li", {
                    key: `${index}-line-${lineIndex}`,
                    staticClass: "list-style-none",
                    domProps: { innerHTML: _vm._s(line) },
                  })
                }),
                0
              ),
              _vm._v(" "),
              !_vm.hide[index] &&
              _vm.getUserLogs(userLog) &&
              _vm.getUserLogs(userLog).length > 0
                ? [
                    _c("UserLogs", {
                      staticClass: "pl-5",
                      attrs: { userLogs: _vm.getUserLogs(userLog) },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }